import React from 'react'
import './ListTicketChatMessage.css';

export default function LoadingMessage() {
  return (
    <div className="loading-message">
        <div className="dot-chatbot dot--one"></div>
        <div className="dot-chatbot dot--two"></div>
        <div className="dot-chatbot dot--three"></div>
    </div>
  )
}
